import React, { Component } from "react";

import { Modal, Button, Col, Row, Form, Input, message } from "antd";
import { addUpdateCareCity } from "../../services";
import { showSuccessNotification } from "../../helpers";

const FormItem = Form.Item;

class AddEditCityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cityName: "",
      cityLat: "",
      cityLng: "",
      orderNumber: "",
      formProcessing: false
    };
  }

  componentDidMount() {
    const { selectedCity } = this.props;
    if (selectedCity) {
      this.setState({
        cityName: selectedCity.name,
        cityLat: selectedCity.latitude,
        cityLng: selectedCity.longitude,
        orderNumber: selectedCity.order_number
      });
    }
  }
  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };
  handleSaveCity = () => {
    const { selectedCity } = this.props;
    const { cityName, cityLat, cityLng, orderNumber } = this.state;

    if (!cityName) {
      message.error("Please enter city name");
      return false;
    }

    const params = {
      name: cityName,
      latitude: cityLat,
      longitude: cityLng,
      order_number: orderNumber
    };

    if (selectedCity && selectedCity.id) {
      params.basic_city_id = selectedCity.basic_city_id;
      params.id = selectedCity.id;
    }
    this.setState({ formProcessing: true });
    addUpdateCareCity(params)
      .then(response => {
        if (response.data.success) {
          showSuccessNotification(
            `City ${
              selectedCity && selectedCity.id ? "Updated" : "added"
            } successfully!`
          );
          this.props.callback();
          setTimeout(() => {
            this.props.toggleModal();
          }, 200);
        }
      })
      .finally(() => {
        this.setState({ formProcessing: false });
      });
  };

  render() {
    const { showModal, toggleModal, selectedCity } = this.props;
    const {
      cityName,
      cityLat,
      cityLng,
      orderNumber,
      formProcessing
    } = this.state;
    return (
      <Modal
        visible={showModal}
        onCancel={toggleModal}
        title={selectedCity ? "Update City" : "Add City"}
        maskClosable={false}
        footer={null}
      >
        <Form>
          <FormItem label="City name">
            <Input
              value={cityName}
              onChange={e => this.handleChange("cityName", e.target.value)}
            />
          </FormItem>
          <Row type="flex" gutter={10}>
            <Col span={12}>
              <FormItem label="City Latitude">
                <Input
                  value={cityLat}
                  onChange={e => this.handleChange("cityLat", e.target.value)}
                />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="City Longitude">
                <Input
                  value={cityLng}
                  onChange={e => this.handleChange("cityLng", e.target.value)}
                />
              </FormItem>
            </Col>
          </Row>
          <FormItem label="City Order">
            <Input
              value={orderNumber}
              onChange={e => this.handleChange("orderNumber", e.target.value)}
            />
          </FormItem>
          <Row gutter={10} type="flex">
            <Col>
              <Button
                type="primary"
                onClick={this.handleSaveCity}
                loading={formProcessing}
              >
                {selectedCity ? "Update" : "Save"}
              </Button>
            </Col>
            <Col>
              <Button type="link" onClick={toggleModal}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default AddEditCityModal;
